import makeEvents from "../../../../helpers/event-creator.js";
const actions = ['add-event-clicked', 'reorder-btn-clicked'];
const ACTIONS = [...actions];
const APP_EVENTS = makeEvents(ACTIONS);
export default APP_EVENTS;
